/**
 * Job Application Form v1.0.0
 */

(function ($) {

  // Job Application Form Page
  var applicationForm = $('#job-application-form');
  var applicationFormSubmitButton = applicationForm.find(':submit');

  // jQuery AJAX form
  var cf = applicationForm.ajaxForm({
    beforeSubmit: function (arr, $form, options) {
      var filled = arr.every(function (input) {
        return input.value !== '';
      });

      if (filled) {
        applicationFormSubmitButton.attr('disabled', true);
        applicationFormSubmitButton.html('<div class="spinner-border spinner-border-sm text-white">');
      }
    },

    success: function (response) {
      // Reset submit button
      applicationFormSubmitButton.html('Apply').attr('disabled', false);

      // If success
      if (response.success === true) {
        $('#alert-submission', applicationForm).show();
        setTimeout(function () { $('#alert-submission', applicationForm).hide() }, 5000);

        cf.clearForm();
        document.getElementById('alert-submission', applicationForm).scrollIntoView();

        // Add conversion tag here.
      }

      // Name
      if (response.success === false && response.data.name) {
        $('input#name', applicationForm).addClass('is-invalid');
        $('#alert-name', applicationForm).text(response.data.name);

        $('#alert-name', applicationForm).show();
        setTimeout(function () {
          $('input#name', applicationForm).removeClass('is-invalid');
          $('#alert-name', applicationForm).text('');
          $('#alert-name', applicationForm).hide();
        }, 5000);
      }

      // Email
      if (response.success === false && response.data.email) {
        $('input#email', applicationForm).addClass('is-invalid');
        $('#alert-email', applicationForm).text(response.data.email);

        $('#alert-email', applicationForm).show();
        setTimeout(function () {
          $('input#email', applicationForm).removeClass('is-invalid');
          $('#alert-email', applicationForm).text('');
          $('#alert-email', applicationForm).hide();
        }, 5000);
      }

      // Phone
      if (response.success === false && response.data.phone) {
        $('input#phone', applicationForm).addClass('is-invalid');
        $('#alert-phone', applicationForm).text(response.data.phone);

        $('#alert-phone', applicationForm).show();
        setTimeout(function () {
          $('input#phone', applicationForm).removeClass('is-invalid');
          $('#alert-phone', applicationForm).text('');
          $('#alert-phone', applicationForm).hide();
        }, 5000);
      }

      // Current location
      if (response.success === false && response.data.current_location) {
        $('input#current-location', applicationForm).addClass('is-invalid');
        $('#alert-current-location', applicationForm).text(response.data.current_location);

        $('#alert-current-location', applicationForm).show();
        setTimeout(function () {
          $('input#current-location', applicationForm).removeClass('is-invalid');
          $('#alert-current-location', applicationForm).text('');
          $('#alert-current-location', applicationForm).hide();
        }, 5000);
      }

      // Current company
      if (response.success === false && response.data.current_company) {
        $('input#current-company', applicationForm).addClass('is-invalid');
        $('#alert-current-company', applicationForm).text(response.data.current_company);

        $('#alert-current-company', applicationForm).show();
        setTimeout(function () {
          $('input#current-company', applicationForm).removeClass('is-invalid');
          $('#alert-current-company', applicationForm).text('');
          $('#alert-current-company', applicationForm).hide();
        }, 5000);
      }

      // Current designation
      if (response.success === false && response.data.current_designation) {
        $('input#current-designation', applicationForm).addClass('is-invalid');
        $('#alert-current-designation', applicationForm).text(response.data.current_designation);

        $('#alert-current-designation', applicationForm).show();
        setTimeout(function () {
          $('input#current-designation', applicationForm).removeClass('is-invalid');
          $('#alert-current-designation', applicationForm).text('');
          $('#alert-current-designation', applicationForm).hide();
        }, 5000);
      }

      // Current ctc
      if (response.success === false && response.data.current_ctc) {
        $('input#current-ctc', applicationForm).addClass('is-invalid');
        $('#alert-current-ctc', applicationForm).text(response.data.current_ctc);

        $('#alert-current-ctc', applicationForm).show();
        setTimeout(function () {
          $('input#current-ctc', applicationForm).removeClass('is-invalid');
          $('#alert-current-ctc', applicationForm).text('');
          $('#alert-current-ctc', applicationForm).hide();
        }, 5000);
      }

      // Expected ctc
      if (response.success === false && response.data.expected_ctc) {
        $('input#expected-ctc', applicationForm).addClass('is-invalid');
        $('#alert-expected-ctc', applicationForm).text(response.data.expected_ctc);

        $('#alert-expected-ctc', applicationForm).show();
        setTimeout(function () {
          $('input#expected-ctc', applicationForm).removeClass('is-invalid');
          $('#alert-expected-ctc', applicationForm).text('');
          $('#alert-expected-ctc', applicationForm).hide();
        }, 5000);
      }

      // Years of Experience
      if (response.success === false && response.data.experience) {
        $('input#experience', applicationForm).addClass('is-invalid');
        $('#alert-experience', applicationForm).text(response.data.experience);

        $('#alert-experience', applicationForm).show();
        setTimeout(function () {
          $('input#experience', applicationForm).removeClass('is-invalid');
          $('#alert-experience', applicationForm).text('');
          $('#alert-experience', applicationForm).hide();
        }, 5000);
      }

      // Notice Period (in days)
      if (response.success === false && response.data.notice_period) {
        $('input#notice_period', applicationForm).addClass('is-invalid');
        $('#alert-notice_period', applicationForm).text(response.data.notice_period);

        $('#alert-notice_period', applicationForm).show();
        setTimeout(function () {
          $('input#notice_period', applicationForm).removeClass('is-invalid');
          $('#alert-notice_period', applicationForm).text('');
          $('#alert-notice_period', applicationForm).hide();
        }, 5000);
      }

      // Resume
      if (response.success === false && response.data.resume) {
        $('input#resume', applicationForm).addClass('is-invalid');
        $('#alert-resume', applicationForm).text(response.data.resume);

        $('#alert-resume', applicationForm).show();
        setTimeout(function () {
          $('input#resume', applicationForm).removeClass('is-invalid');
          $('#alert-resume', applicationForm).text('');
          $('#alert-resume', applicationForm).hide();
        }, 5000);
      }

      if (response.success === false && response.data.captcha) {
        $('input#captcha', applicationForm).addClass('is-invalid');
        $('#alert-captcha', applicationForm).text(response.data.captcha);

        $('#alert-captcha', applicationForm).show();
        setTimeout(function () {
          $('input#captcha', applicationForm).removeClass('is-invalid');
          $('#alert-captcha', applicationForm).text('');
          $('#alert-captcha', applicationForm).hide();
        }, 5000);
      }
    },

    error: function (response) {
      console.error(response);

      // Reset submit button
      applicationFormSubmitButton.html('Apply').attr('disabled', false);

      $('#alert-submission-failed', applicationForm).show();
      setTimeout(function () { $('#alert-submission-failed', applicationForm).hide() }, 5000);

      document.getElementById('alert-submission-failed', applicationForm).scrollIntoView();
    },
  });

})(jQuery);
